const Plugin = {};

const key = 'jwt';

class Auth {
  getToken() {
    return window.localStorage.getItem(key) || '';
  }

  hasToken() {
    return this.getToken().length > 0;
  }

  setToken(token) {
    window.localStorage.setItem(key, token);
  }

  removeToken() {
    window.localStorage.removeItem(key);
  }
}

Plugin.install = function (Vue) {
  const auth = new Auth();

  Vue.$auth = auth;
  Vue.prototype.$auth = auth;
}

export default Plugin;
